import React, { useState, useEffect } from 'react';
import styles from './CategoryEdtSelectModal.module.css';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AxiosUrl from '../AxiosUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CategoryEdtSelectModal({ setOpenModal, data }) {
    const [category, setCategory] = useState('');
    const [SelectData, setSelectData] = useState();
    const [loading, setloading] = useState(false);
    const uid = localStorage.getItem('id');

    const fromData = {
        uid,
        HcategoryID: data._id,
        CategoryData: SelectData,
    };

    const SelectCategory = () => {
        if (SelectData) {
            setloading(true);
            AxiosUrl.post(`/home-edit-category/${uid}`, fromData)
                .then((res) => {
                    setOpenModal(false);
                })
                .catch((error) => {
                    console.log(error.response.data);
                });
        }
    };

    useEffect(() => {
        AxiosUrl.get(`/category/${uid}`)
            .then((data) => {
                setCategory(data.data);
            })
            .catch((error) => {});
    }, []);

    return (
        <div className={styles.modalBackground}>
            <ToastContainer />
            <div className={styles.modalContainer}>
                <div className={styles.titleCloseBtn}>
                    <button
                        onClick={() => setOpenModal(false)}
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#f3f4f6',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#6b7280',
                            transition: 'all 0.2s',
                        }}
                    >
                        ×
                    </button>
                </div>
                <h2
                    style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#202223',
                        margin: '0 0 8px 0',
                        textAlign: 'center',
                    }}
                >
                    Select Category
                </h2>
                <p
                    style={{
                        textAlign: 'center',
                        fontSize: '14px',
                        color: '#6d7175',
                        margin: '0 0 24px 0',
                        padding: '12px',
                        backgroundColor: '#f0f9ff',
                        border: '1px solid #bae6fd',
                        borderRadius: '8px',
                    }}
                >
                    Double Click to Select Category From The Below List
                </p>
                {loading && (
                    <p
                        style={{
                            textAlign: 'center',
                            fontSize: '14px',
                            color: '#6d7175',
                            padding: '20px',
                        }}
                    >
                        Loading...
                    </p>
                )}

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        maxHeight: '400px',
                        overflowY: 'auto',
                    }}
                >
                    {category &&
                        category.map((data) => {
                            return (
                                <div
                                    key={data._id}
                                    style={{
                                        backgroundColor: '#385879',
                                        padding: '14px 16px',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        color: '#fff',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                    }}
                                    onClick={() => {
                                        setSelectData(data);
                                        SelectCategory();
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#2d4a64';
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#385879';
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    {data.name}
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

export default CategoryEdtSelectModal;